import React from 'react';

interface ValidFileIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const JetBrainsIcon: React.FC<ValidFileIconProps> = ({
  className = '',
  width = 42,
  height = 51,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_1128_680)">
        <mask
          id="mask0_1128_680"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <path d="M20 0H0V20H20V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1128_680)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 0H0V20H20V0ZM9.2266 16.25H1.72656V17.5H9.2266V16.25ZM1.64062 5.26615L2.22268 4.71665C2.38103 4.90757 2.53006 5.01935 2.73494 5.01935C2.95846 5.01935 3.10285 4.86568 3.10285 4.563V2.5H4.00163V4.56763C4.00163 4.97743 3.89917 5.26615 3.68031 5.48505C3.46603 5.6993 3.15877 5.81565 2.7862 5.81565C2.21806 5.81565 1.87346 5.57815 1.64062 5.26615ZM6.83271 2.5H4.21094V5.75975H6.85601V4.9914H5.10506V4.47448H6.66971V3.762H5.10506V3.26372H6.83271V2.5ZM8.0123 3.29166H7.03906V2.5H9.8937V3.29166H8.9158V5.75975H8.0123V3.29166ZM4.49725 7.35249C4.49725 7.72969 4.28313 7.95324 3.99439 8.0789C4.39025 8.2092 4.6417 8.4327 4.64168 8.8751V8.8844C4.64168 9.4432 4.1853 9.7832 3.40765 9.7832H1.72656V6.52344H3.39819C3.80799 6.52344 4.09673 6.62589 4.28765 6.81219C4.3563 6.88219 4.41021 6.96524 4.44621 7.05644C4.48221 7.14764 4.49957 7.24514 4.49725 7.34319V7.35249ZM3.1981 7.25004H2.60668V7.82284H3.17482C3.44956 7.82284 3.6079 7.72969 3.6079 7.53879V7.52944C3.6079 7.34784 3.46353 7.25004 3.1981 7.25004ZM3.30522 9.0569C3.58462 9.0569 3.7383 8.9498 3.7383 8.7588V8.7495C3.7383 8.5725 3.59859 8.4561 3.2959 8.4561H2.60668V9.0569H3.30522ZM9.593 6.5H8.7223L7.50429 9.3913L6.99474 8.6468C7.39989 8.4744 7.66529 8.1439 7.66529 7.64095V7.6316C7.66529 7.3103 7.56754 7.06345 7.37674 6.87255C7.15784 6.65365 6.81324 6.5233 6.31494 6.5233H4.77344V9.7831H5.67684V8.7959H6.07734L6.73394 9.7831H8.2844L8.5173 9.1964H9.7792L10.0121 9.7831H10.9806L9.593 6.5ZM6.76174 7.70145C6.76174 7.93895 6.58014 8.088 6.27744 8.088H5.67689V7.30095H6.27299C6.57104 7.30095 6.76194 7.43135 6.76194 7.69215L6.76174 7.70145ZM8.7828 8.493L9.1507 7.571L9.5139 8.493H8.7828ZM11.9932 6.52344H11.0898V9.7832H11.9932V6.52344ZM12.2148 6.52344H13.0577L14.3989 8.2465V6.52344H15.293V9.7832H14.506L13.109 7.99504V9.7832H12.2148V6.52344ZM15.8544 8.6954L15.3516 9.2962C15.7567 9.6547 16.3015 9.8363 16.879 9.8362C17.6706 9.8362 18.1969 9.4404 18.1969 8.7744V8.7651C18.1969 8.1551 17.7312 7.91284 16.9861 7.74999C16.5297 7.64759 16.418 7.58234 16.418 7.43334V7.42414C16.418 7.30314 16.5251 7.21459 16.7439 7.21459C17.0327 7.21459 17.3586 7.32159 17.6567 7.53589L18.1081 6.89794C17.7542 6.61389 17.3213 6.46484 16.767 6.46484C15.9846 6.46484 15.505 6.90259 15.505 7.50799V7.51729C15.505 8.1832 16.0405 8.3788 16.7344 8.5371C17.1816 8.6442 17.2887 8.7141 17.2887 8.8538V8.8631C17.2887 9.0028 17.1584 9.0866 16.9116 9.0866C16.5344 9.0866 16.1804 8.9516 15.8544 8.6954Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1128_680">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
